/** Usuário fechou o popup do Google antes de concluir o login (fluxo normal, sem mensagem de erro). */
export function isFirebasePopupClosedByUser(err: unknown): boolean {
  const code =
    err && typeof err === 'object' && 'code' in err
      ? String((err as { code?: string }).code)
      : '';
  if (code === 'auth/popup-closed-by-user') return true;
  const msg = err instanceof Error ? err.message : '';
  return /popup-closed-by-user/i.test(msg);
}
